import axios from "axios";

const _API = axios.create({
  // withCredentials: true
});

_API.interceptors.response.use((response) => {
  return Promise.resolve(response.data);
});

/**
 * Add API_URL to request url before sending request.
 */
_API.interceptors.request.use((config) => {
  if (process.env.NODE_ENV === "development") {
    config.url = `${process.env.REACT_APP_API_URL}${config.url}`;
  } else {
    config.url = `${process.env.REACT_APP_PROD_API_URL}${config.url}`;
  }
  // config.withCredentials = true;
  return config;
});

export default _API;
